<template>
  <div ref="swiper" class="swiper-container">
    <div class="swiper-wrapper"
         :class="{isDragging}"
         :style="{left: slidePosition}"
         ref="slides"
         @mousedown="onHandleStart"
         @touchstart="onHandleStart"
    >
      <div class="list1 swiper-slide" :class="{ active: currentIndex === 0, [$i18n.locale]: true }">
        <div class="swiper-content--wrap">
          <figure class="img--wrap"></figure>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.step2.group.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.step2.group.desc')"></li>
              <li class="desc" v-html="$t('page.registration.guide.step2.group.desc2')"></li>
              <li class="desc" v-html="$t('page.registration.guide.step2.group.desc3')"></li>
            </ul>
            <a class="match-select-guide learn-more" :href="matchGuideLink" target="_blank" v-html="$t('page.registration.guide.learnMore')"></a>
          </div>
        </div>
      </div>
      <div class="list2 swiper-slide" :class="{ active: currentIndex === 1, [$i18n.locale]: true }">
        <div class="swiper-content--wrap">
          <figure class="img--wrap"></figure>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.step2.page.title') }}</p>
            <ul>
              <li class="desc">{{ $t('page.registration.guide.step2.page.desc') }}</li>
              <li class="desc">{{ $t('page.registration.guide.step2.page.desc2') }}</li>
            </ul>
            <a class="match-select-guide learn-more" :href="matchGuideLink" target="_blank" v-html="$t('page.registration.guide.learnMore')"></a>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-pagination" slot="pagination" ref="pagination">
      <template v-for="index in slides.length">
        <span
          :key="index"
          class="dot"
          :class="{ active: index - 1 === currentIndex }"
          @click="goToSlide(index - 1)"
        ></span>
      </template>
    </div>
    <div v-show="!isFirstSlide"
         ref="swiperLeft"
         class="swiper-button-prev icon icon--prev-white-size20"
         @click="prevSlide"
    ></div>
    <div v-show="!isLastSlide"
         ref="swiperRight"
         class="swiper-button-next icon icon--prev-white-size20"
         @click="nextSlide"
    ></div>
  </div>
</template>

<script>
export default {
  props: [
    'focusContent'
  ],
  data () {
    return {
      slides: [],
      currentIndex: 0,
      isDragging: false,
      startX: 0,
      endX: 0,
      dragOffset: 0,
      slidePosition: null
    }
  },
  computed: {
    isFirstSlide () {
      return this.currentIndex === 0
    },
    isLastSlide () {
      if (this.slides) {
        return this.currentIndex === this.slides.length - 1
      }
      return false
    },
    matchGuideLink () {
      switch (this.$i18n.locale) {
        case 'ko':
          return 'https://forum.beusable.net/ko/solomon/post/734'
        case 'en':
          return 'https://forum.beusable.net/en/solomon/post/1434'
        case 'ja':
          return 'https://forum.beusable.net/ja/solomon/post/1627'
        default:
          return null
      }
    }
  },
  mounted () {
    this.slides = document.querySelectorAll('.swiper-slide')

    if (this.$refs.pagination.children.length !== 0) {
      if (this.focusContent.currentContentIndex < 7) {
        this.$refs.pagination.children[this.focusContent.currentContentIndex].click()
      } else {
        this.$refs.pagination.children[this.slideCurrentIndex].click()
      }
    }

    this.getTransformStyle()
  },
  watch: {
    focusContent () {
      if (this.focusContent.currentStep === 1) {
        const contentIndex = this.focusContent.currentContentIndex
        this.$refs.pagination.children[contentIndex].click()
      }
    }
  },
  methods: {
    nextSlide () {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
      this.getTransformStyle()
    },
    prevSlide () {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length
      this.getTransformStyle()
    },
    goToSlide (index) {
      this.currentIndex = index
      this.getTransformStyle()
    },
    onHandleStart (event) {
      this.isDragging = true
      this.startX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = 0
      if (this.isDragging) {
        window.addEventListener('mousemove', this.onHandleMove)
        window.addEventListener('mouseup', this.onHandleEnd)
      }
    },
    onHandleMove (event) {
      if (!this.isDragging) return

      const currentX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = currentX - this.startX
      const dragTranslate = (this.dragOffset / 480) * 100
      const baseTranslate = -this.currentIndex * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    onHandleEnd () {
      if (!this.isDragging) return

      if (this.dragOffset > 50) {
        this.prevSlide()
      } else if (this.dragOffset < -50) {
        this.nextSlide()
      } else {
        this.resetDrag()
      }
      this.isDragging = false
      this.startX = 0
      this.endX = 0
      this.getTransformStyle()
    },
    getTransformStyle () {
      const baseTranslate = -this.currentIndex * 100
      const dragTranslate = (this.endX / 480) * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    resetDrag () {
      this.dragOffset = 0
    }
  }
}
</script>
